<template>
  <div class="blog">
    <div class="container background-container">
      <div class="row">
        <div class="col-md-12 p-0 pt-4">
          <img
            class="blog__header-image"
            src="@/assets/images/blog/divyateachesechildrenaboutcooking/header.jpg"
            alt="header-image"
          />
        </div>
      </div>
    </div>

    <div class="container p-md-0">
      <div class="row">
        <div class="col-md-12 p-md-0">
          <h1 class="blog__title">
            Supporting stars of the future, like Divya
          </h1>
        </div>
      </div>

      <div class="row position-relative">
        <div
          v-if="userAgent && !isInstagramBrowser"
          class="blog__social d-md-flex d-none"
        >
          <span class="blog__social-title">Share</span>
          <div
            v-for="(link, key) in socialLinks"
            :key="key"
            class="mt-2"
            @click="handleShareClick"
          >
            <img :src="getImageItem(key)" :alt="key" />
          </div>
        </div>
        <div class="col-md-8 offset-md-2">
          <p>
            Many of the home cooks – both in the UK and USA – who have
            discovered Found have seen how this can open a whole new career for
            them.
          </p>
          <p>
            Their vast online following has been only too willing to purchase
            their cookery books, giving them the opportunity to recreate in
            their own homes the dishes they’ve seen on social media.
          </p>
          <p>
            Georgia, from Bournemouth, decided to share her personal experience
            on social media, rapidly gaining tens of thousands of followers.
          </p>

          <p>
            The cookery books have brought in a very welcome extra revenue
            stream for these creators and of course the bigger their audience,
            the more books they are likely to sell.
          </p>

          <p>
            But at Found we’re not only interested in helping those who have
            tens of thousands of followers – we’re also interested in investing
            and supporting the stars of the future.
          </p>

          <p>
            Hertfordshire based mum of two Divya Maru is a case in point. Like
            so many of our Found alumni, she used lockdown to hone her cooking
            skills and then decided to share her recipes with an online
            audience.
          </p>
        </div>

        <div class="col-md-8 offset-md-2">
          <div class="blog__double-image">
            <img
              src="@/assets/images/blog/divyateachesechildrenaboutcooking/1.jpg"
              alt="image"
            />
            <img
              src="@/assets/images/blog/divyateachesechildrenaboutcooking/4.jpg"
              alt="image"
            />
          </div>
        </div>

        <div class="col-md-8 offset-md-2 mt-3">
          <p>
            At present Divya has over 8750 followers – a number that is growing
            – and hopefully with the support of Found those followers will grow
            and allow her to not only make money but also to help her fulfill
            her passion.
          </p>
          <p>
            For Divya teaching children about cooking is a skill for life – and
            also helps them in so many other areas of their education.
          </p>

          <p>
            It’s not just about preparing food – cooking helps young people with
            science, math’s and gives them discipline and as someone who runs a
            tutoring business, she completely understands the importance of
            shaping young minds to prepare them for the future.
          </p>
          <p>
            Divya has done this with her own kids and now her mission is to
            spread the word far and wide – which is what Found is helping her
            with.
          </p>
        </div>

        <div class="col-md-8 offset-md-2">
          <div class="blog__double-image">
            <img
              src="@/assets/images/blog/divyateachesechildrenaboutcooking/2.jpg"
              alt="image"
            />
            <img
              src="@/assets/images/blog/divyateachesechildrenaboutcooking/3.jpg"
              alt="image"
            />
          </div>
        </div>

        <div class="col-md-8 offset-md-2 mt-3">
          <p>
            Her many recipes for quick and easy home cooked food which draw
            their inspiration from global cuisines – think Indian, Mexican and
            Italian – are now inspiring many people via her @mum_im_hungry_
            Instagram and TikTok accounts.
          </p>
          <p>
            She’s now part of the Found family and with that comes the support
            she needs to help grow her fan base and supplement her income.
          </p>
          <p>
            When you sign up with Found, it’s not just about us working with you
            to produce a cookery book – or to showcase the other merchandise
            which can be personalised to your brand.
          </p>
          <p>
            We can hook you up with our expert team who can help with your brand
            development, your logo – in fact all of the basics that anyone who
            is serious about succeeding in business needs.
          </p>
          <p>
            You may not have the huge numbers at the point we start to work
            together but when we recognise potential – as in the case of Divya –
            we are happy to put our resources behind you to help you reach that
            potential.
          </p>
          <p>
            We can also devise a PR plan suited to your expertise and your
            story. It can range from publicity in your local press to putting
            you – and your recipes – forward for opportunities in papers,
            magazines or even on tv and radio.
          </p>
          <p>
            Divya is one of our next generations of Found creators and we are
            working closely with her to help her achieve her aims – and to grow
            her platforms.
          </p>
          <p>
            This will include a proactive PR campaign to help raise her profile
            and in turn get her new followers.
          </p>
          <p>
            It’s all part of the Found commitment and the value we put on
            working in partnership.
          </p>
          <p>
            We are looking for people who want to be part of the Found journey
            and enjoy all the benefits that can bring. Could that be you?
          </p>

          <div
            v-if="userAgent && !isInstagramBrowser"
            class="blog__social d-md-none"
          >
            <span class="blog__social-title">Share</span>
            <div class="d-flex">
              <div
                v-for="(link, key) in socialLinks"
                :key="key"
                class="mt-2 mr-md-0 mr-3"
                @click="handleShareClick"
              >
                <img :src="getImageItem(key)" :alt="key" />
              </div>
            </div>
          </div>

          <div v-if="tags && tags.length">
            <h2 class="mt-4">Related topics</h2>
            <div class="blog__tags">
              <Tag
                v-for="tag in tags"
                :key="tag"
                class="mr-3 my-2"
                @click="onTagClick(tag)"
              >
                {{ tag }}
              </Tag>
            </div>
          </div>

          <div class="blog__action-button mt-5">
            <Button
              class="pt-2"
              full-width
              size="sm"
              @click="handleBeFoundClick"
            >
              I’m ready to talk
            </Button>
          </div>

          <div class="blog__action-button mt-3 mb-5">
            <Button
              class="pt-2"
              full-width
              size="sm"
              variant="outline"
              @click="$router.push('/blog')"
            >
              View all blogs
            </Button>
          </div>

          <Carousel
            v-if="creatorProducts && creatorProducts.length"
            id="blog-products"
            class="my-4"
            :items="creatorProducts"
            :mode="CarouselModes.PRODUCT"
            show-default-item-actions
            @click="handleProductBundleClick"
          >
            <template #title>
              <h2>More from {{ creatorHandle }}</h2>
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { throttle } from 'lodash';
import socialLinks from '@/misc/socialLinks';
import { CarouselModes, WebApiCancelError } from '@/misc/constants';
import Tag from '@/components/Elements/Tag.vue';
import Button from '@/components/Elements/Button.vue';
import getDefaultProductFormat from '@/misc/getDefaultProductFormat';
import formatMoney from '@/misc/formatMoney';
import getFormatPrice from '@/misc/getFormatPrice';
import { fetchProductsByCreator } from '@/services/products';
import filterProductsByRegion from '@/misc/filterProductByRegion';

export default {
  name: 'BlogItemPage',
  components: {
    Button,
    Tag,
    Carousel: () =>
      import(/* webpackPrefetch: true */ '@/components/Carousel/Index')
  },

  data() {
    return {
      creatorHandle: 'mum_im_hungry_',
      CarouselModes,
      socialLinks,
      creatorProducts: [],
      tags: ['Creator Stories']
    };
  },

  head: {
    title: 'Be Found | Blog'
  },

  computed: {
    ...mapState('main', ['userAgent']),
    ...mapGetters({
      isInstagramBrowser: 'main/isInstagramBrowser',
      currency: 'config/currency',
      region: 'config/region'
    })
  },

  mounted() {
    fetchProductsByCreator(this.$axios, this.creatorHandle)
      .then((response) => {
        const creatorProducts = this.$get(response, 'creatorProducts');
        this.creatorProducts = filterProductsByRegion(
          creatorProducts,
          this.region
        );
        this.contributedProducts = filterProductsByRegion(
          this.$get(response, 'contributedProducts'),
          this.region
        );
      })
      .catch((err) => {
        this.$showToastMessage(
          this.$get(err, 'response.data.message'),
          'Error',
          'danger'
        );
      });
  },

  methods: {
    getImageItem(key) {
      return require(`@/assets/icons/social/${key}.svg`);
    },

    onTagClick(tag) {
      this.$router.push('/blog?filter=' + tag);
    },

    handleBeFoundClick() {
      this.$router.push({ path: '/be-found' });
    },

    handleShareClick: throttle(function () {
      const url = window.location.href;
      if (navigator?.share) {
        navigator.share({ url }).catch((err) => {
          if (!err.message.includes(WebApiCancelError)) {
            this.$showToastMessage(err.message, 'Error', 'error');
          }
        });
      } else if (navigator?.clipboard) {
        navigator.clipboard
          .writeText(url)
          .then(() =>
            this.$showToastMessage('Link is copied', 'Success', 'success')
          )
          .catch((err) =>
            this.$showToastMessage(
              `Failed to copied link ${err.message}`,
              'Error',
              'error'
            )
          );
      } else {
        this.$showToastMessage(
          `Sharing function is not supported`,
          'Error',
          'error'
        );
      }
    }, 1500),

    getProductFormatPrice(product) {
      const defaultFormat = getDefaultProductFormat(product);
      return formatMoney(
        getFormatPrice(defaultFormat, this.region)?.amount,
        this.currency
      );
    },

    handleProductBundleClick(product) {
      this.$router.push({
        path: `/products/${product.id || product.item.id}`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.blog {
  &__header-image {
    object-fit: cover;
    height: 480px;
    width: 100%;
  }

  &__title {
    padding-top: 40px;
    text-align: left;
    line-height: 56px;
  }

  &__landscape-image {
    object-fit: cover;
    transform: translate3d(0, 0, 1px);
    height: 550px;
    width: 100%;
    margin-bottom: 40px;
  }

  &__social {
    position: absolute;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    text-align: center;

    &-title {
      font-size: 12px;
    }
  }

  &__double-image {
    display: flex;
    justify-content: space-around;

    img {
      object-fit: cover;
      height: 700px;
      &:first-child {
        margin-right: 20px;
      }
    }
  }

  &__quote {
    font-family: 'Poppins-SemiBold', sans-serif;
    font-size: 24px;
    border-left: 8px solid $primary-color;
    padding-left: 35px;
  }

  &__action-button {
    margin: 0 auto;
    max-width: 240px;
  }

  @media (max-width: $screen-width-md) {
    &__header-image {
      object-fit: contain;
      height: 242px;
    }

    &__landscape-image {
      height: 328px;
    }

    &__double-image {
      flex-wrap: wrap;

      img {
        margin-bottom: 25px;
        object-fit: cover;
        height: 420px;
        &:first-child {
          margin-right: 0;
        }
      }
    }

    &__social {
      position: initial;
      flex-direction: column;
      text-align: left;
    }
  }
}
</style>
